export default __webpack_public_path__ + "9a73d466cb3b8af88aecc9592c5db238.svg";